/**
 * Маппинг ISO кодов стран на русские названия
 */
export const countryNames = {
    'FI': 'Финляндия',
    'DE': 'Германия',
    'NL': 'Нидерланды',
    'US': 'США',
    'SG': 'Сингапур',
    'LV': 'Латвия',
    'GB': 'Великобритания',
    'FR': 'Франция',
    'IT': 'Италия',
    'ES': 'Испания',
    'PL': 'Польша',
    'CZ': 'Чехия',
    'AT': 'Австрия',
    'CH': 'Швейцария',
    'SE': 'Швеция',
    'NO': 'Норвегия',
    'DK': 'Дания',
    'NG': 'Нигерия',
    'EE': 'Эстония',
};
